import React, { Component } from 'react';
import StyledDetails from './ProductDetails.style';
import Modal from './Modal';
import { translate } from 'react-polyglot';

class ProductDetails extends Component {
  render = () => {
    const { selectedProduct, configOptions, t } = this.props;

    return (
      <Modal onClick={this.props.closeProductDetails} open={selectedProduct}>
        <StyledDetails>
          <h2 className="title">{selectedProduct ? selectedProduct.name : null}</h2>
          <span className="location">{t('product_location')}</span>

          <div className="productDesc">
            <img src={selectedProduct ? selectedProduct.image : null} alt="" />
            <div className="desc">
              <p>{selectedProduct ? selectedProduct.description : null}</p>

              {/*<span className="quantity">1 fl oz. / 30 ml</span>*/}
              {selectedProduct && selectedProduct.custom_data && selectedProduct.custom_data.rating && (
                <div className="ratingSection">
                  <div className="ratingValue">User rate: {selectedProduct.custom_data.rating} / 5</div>
                  <div className="reviewCountValue">Based on {selectedProduct.custom_data.reviewCount} reviews</div>
                </div>
              )}
            </div>
          </div>

          <div className="actions">
            {configOptions.results.buyNowButton && configOptions.results.buyNowButton.show && (
              <button
                disabled={!configOptions.results.buyNowButton.callback}
                onClick={
                  configOptions.results.buyNowButton.callback ? eval(configOptions.results.buyNowButton.callback) : null
                }
              >
                {configOptions.results.buyNowButton.text}
              </button>
            )}
          </div>
        </StyledDetails>
      </Modal>
    );
  };
}

export default translate()(ProductDetails);



// WEBPACK FOOTER //
// ./src/components/instore/ProductDetails.js